var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_5545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.005 0H19.995C8.9675 0 0 8.97 0 20C0 24.375 1.41 28.43 3.8075 31.7225L1.315 39.1525L9.0025 36.695C12.165 38.79 15.9375 40 20.005 40C31.0325 40 40 31.0275 40 20C40 8.9725 31.0325 0 20.005 0Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6531 28.2434C31.1706 29.6059 29.2556 30.7359 27.7281 31.0659C26.6831 31.2884 25.3181 31.4659 20.7231 29.5609C14.8456 27.1259 11.0606 21.1534 10.7656 20.7659C10.4831 20.3784 8.39062 17.6034 8.39062 14.7334C8.39062 11.8634 9.84813 10.4659 10.4356 9.86594C10.9181 9.37344 11.7156 9.14844 12.4806 9.14844C12.7281 9.14844 12.9506 9.16094 13.1506 9.17094C13.7381 9.19594 14.0331 9.23094 14.4206 10.1584C14.9031 11.3209 16.0781 14.1909 16.2181 14.4859C16.3606 14.7809 16.5031 15.1809 16.3031 15.5684C16.1156 15.9684 15.9506 16.1459 15.6556 16.4859C15.3606 16.8259 15.0806 17.0859 14.7856 17.4509C14.5156 17.7684 14.2106 18.1084 14.5506 18.6959C14.8906 19.2709 16.0656 21.1884 17.7956 22.7284C20.0281 24.7159 21.8381 25.3509 22.4856 25.6209C22.9681 25.8209 23.5431 25.7734 23.8956 25.3984C24.3431 24.9159 24.8956 24.1159 25.4581 23.3284C25.8581 22.7634 26.3631 22.6934 26.8931 22.8934C27.4331 23.0809 30.2906 24.4934 30.8781 24.7859C31.4656 25.0809 31.8531 25.2209 31.9956 25.4684C32.1356 25.7159 32.1356 26.8784 31.6531 28.2434Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_5545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsappLogo.e03cddca2313d1b17a02d2ef72acd57d.svg";
export { ForwardRef as ReactComponent };